<template>
    <div class="OnboardingManagementList">
        <HeaderPage></HeaderPage>
        <el-card v-loading="loadingPage">
            <el-row class="borderbody">
                <div class="grid-content">
                    <h1>
                        <b>Etapas do Onboarding</b>
                        <el-tooltip 
                            effect="light" 
                            placement="top">
                            <template #content>
                                Esta tela oferece a visão das etapas de credenciamento e onde os estabelecimentos se encontram.<br> 
                                Para ter uma visão rápida das pendências de cada etapa, basta clicar no respectivo retângulo.<br>
                                Ao fazer isso, você terá a visão dos estabelecimentos que estão com problemas a serem resolvidos.<br>
                                Na coluna "Orientação" você terá uma ajuda de como prosseguir dado o status.
                            </template>
                            <svg x="98" y="2" width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <ellipse cx="14.5" cy="13.7564" rx="14.5" ry="13.7564" fill="#2966C8"/>
                                <path d="M11.982 17.6562V17.3068C11.982 16.3409 12.0615 15.571 12.2206 14.9972C12.3854 14.4233 12.624 13.9631 12.9365 13.6165C13.249 13.2642 13.6297 12.9432 14.0786 12.6534C14.4365 12.4261 14.7547 12.196 15.0331 11.9631C15.3172 11.7244 15.5417 11.4687 15.7064 11.196C15.8712 10.9233 15.9536 10.6136 15.9536 10.267C15.9536 9.93182 15.874 9.63636 15.715 9.38068C15.5559 9.125 15.3371 8.92898 15.0587 8.79261C14.786 8.65057 14.482 8.57954 14.1468 8.57954C13.8115 8.57954 13.4962 8.65625 13.2007 8.80966C12.911 8.96307 12.6723 9.18182 12.4848 9.46591C12.303 9.74432 12.2093 10.0824 12.2036 10.4801H8.28313C8.30018 9.28693 8.57575 8.30966 9.10984 7.54829C9.64961 6.78693 10.3627 6.22443 11.249 5.86079C12.1354 5.49148 13.1127 5.30682 14.1809 5.30682C15.3513 5.30682 16.3911 5.48864 17.3002 5.85227C18.215 6.21591 18.9337 6.75284 19.4564 7.46307C19.9792 8.17329 20.2405 9.04261 20.2405 10.071C20.2405 10.7472 20.1269 11.3437 19.8996 11.8608C19.6723 12.3778 19.3542 12.8352 18.9451 13.233C18.5417 13.625 18.0672 13.983 17.5218 14.3068C17.0956 14.5568 16.7405 14.8182 16.4564 15.0909C16.178 15.3636 15.9678 15.6761 15.8257 16.0284C15.6837 16.375 15.6127 16.8011 15.6127 17.3068V17.6562H11.982ZM13.8655 23.2472C13.2519 23.2472 12.7263 23.0312 12.2888 22.5994C11.857 22.1676 11.6439 21.6449 11.6496 21.0312C11.6439 20.429 11.857 19.9148 12.2888 19.4886C12.7263 19.0568 13.2519 18.8409 13.8655 18.8409C14.4507 18.8409 14.965 19.0568 15.4081 19.4886C15.8513 19.9148 16.0757 20.429 16.0814 21.0312C16.0757 21.4403 15.9678 21.8125 15.7576 22.1477C15.553 22.483 15.2831 22.75 14.9479 22.9489C14.6184 23.1477 14.2576 23.2472 13.8655 23.2472Z" fill="white"/>
                            </svg>
                        </el-tooltip>
                    </h1>
                </div>
                <div class="grid-content">
                    <FilterBox v-on:filterExport="exportDados" v-on:filterList="getOnboardingData" v-on:filterStatus="filterOnboardingData" :countStatus="countStatus" :total="onboardingList.total"/>
                </div>
                <div class="grid-content">
                    <el-row class="LinhaTable">
                        <el-col :span="22">
                            <TableSimple :list-data="onboardingList" >
                                <el-table-column prop="created_at" label="Data" width="130">
                                    <template slot-scope="scope">
                                        {{moment(scope.row.created_at).format('DD/MM/YY HH:mm')}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="marketplace_name" label="Marketplace" />
                                <el-table-column prop="document" label="Documento">
                                    <template slot-scope="scope">
                                        <a 
                                            style="color: inherit;text-decoration: inherit;"
                                            target="_blank"
                                            :href="
                                                $router.resolve({
                                                    name: 'records.departments.edit',
                                                    params: { id: scope.row.department_store_id },
                                                }).href
                                            ">
                                            {{ (scope.row.business_cnpj) ? scope.row.business_cnpj : scope.row.cpf }}
                                        </a>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="name_store" label="Nome">
                                    <template slot-scope="scope">
                                        <a 
                                            style="color: inherit;text-decoration: inherit;"
                                            target="_blank"
                                            :href="
                                                $router.resolve({
                                                    name: 'records.departments.edit',
                                                    params: { id: scope.row.department_store_id },
                                                }).href
                                            ">
                                            {{ scope.row.name_store }}
                                        </a>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="phone" label="Telefone" />
                                <el-table-column prop="email" label="E-mail" />
                                <el-table-column prop="status" label="Etapa">
                                    <template slot-scope="scope">
                                        <EtapaCapta v-if="scope.row.status" :status="scope.row.status" />
                                        <el-tag v-else type="info">Não Enviado</el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="status" label="Status" min-width="130">
                                    <template slot-scope="scope">
                                        <StatusCaptaSemTip v-if="scope.row.status" :status="scope.row.status" />
                                        <el-tag v-else type="info">Não Enviado</el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column min-width="200">
                                    <template slot="header">
                                        <el-tooltip effect="light" placement="top" style="position: relative;top: 0px; left: 105px;">
                                            <template #content>
                                                Essa coluna permite que você tenha uma compreensão melhor de como prosseguir caso haja alguma pendência ou se é necessário aguardar enquanto algum processamento é realizado.
                                            </template>
                                            <svg x="98" y="2" width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <ellipse cx="14.5" cy="13.7564" rx="14.5" ry="13.7564" fill="#2966C8"/>
                                                <path d="M11.982 17.6562V17.3068C11.982 16.3409 12.0615 15.571 12.2206 14.9972C12.3854 14.4233 12.624 13.9631 12.9365 13.6165C13.249 13.2642 13.6297 12.9432 14.0786 12.6534C14.4365 12.4261 14.7547 12.196 15.0331 11.9631C15.3172 11.7244 15.5417 11.4687 15.7064 11.196C15.8712 10.9233 15.9536 10.6136 15.9536 10.267C15.9536 9.93182 15.874 9.63636 15.715 9.38068C15.5559 9.125 15.3371 8.92898 15.0587 8.79261C14.786 8.65057 14.482 8.57954 14.1468 8.57954C13.8115 8.57954 13.4962 8.65625 13.2007 8.80966C12.911 8.96307 12.6723 9.18182 12.4848 9.46591C12.303 9.74432 12.2093 10.0824 12.2036 10.4801H8.28313C8.30018 9.28693 8.57575 8.30966 9.10984 7.54829C9.64961 6.78693 10.3627 6.22443 11.249 5.86079C12.1354 5.49148 13.1127 5.30682 14.1809 5.30682C15.3513 5.30682 16.3911 5.48864 17.3002 5.85227C18.215 6.21591 18.9337 6.75284 19.4564 7.46307C19.9792 8.17329 20.2405 9.04261 20.2405 10.071C20.2405 10.7472 20.1269 11.3437 19.8996 11.8608C19.6723 12.3778 19.3542 12.8352 18.9451 13.233C18.5417 13.625 18.0672 13.983 17.5218 14.3068C17.0956 14.5568 16.7405 14.8182 16.4564 15.0909C16.178 15.3636 15.9678 15.6761 15.8257 16.0284C15.6837 16.375 15.6127 16.8011 15.6127 17.3068V17.6562H11.982ZM13.8655 23.2472C13.2519 23.2472 12.7263 23.0312 12.2888 22.5994C11.857 22.1676 11.6439 21.6449 11.6496 21.0312C11.6439 20.429 11.857 19.9148 12.2888 19.4886C12.7263 19.0568 13.2519 18.8409 13.8655 18.8409C14.4507 18.8409 14.965 19.0568 15.4081 19.4886C15.8513 19.9148 16.0757 20.429 16.0814 21.0312C16.0757 21.4403 15.9678 21.8125 15.7576 22.1477C15.553 22.483 15.2831 22.75 14.9479 22.9489C14.6184 23.1477 14.2576 23.2472 13.8655 23.2472Z" fill="white"/>
                                            </svg>
                                        </el-tooltip>
                                    <span>Orientação</span>
                                    </template>
                                    <template slot="default" slot-scope="scope" :statusMessages="this.statusMessages">
                                        {{ statusMessages[scope.row.status] }}
                                    </template>
                                </el-table-column>
                            </TableSimple>
                        </el-col>
                    </el-row>
                </div>

            </el-row>
        </el-card>
    </div>
</template>

<script>
    import HeaderPage from "@/app/components/HeaderPage";
    import TableSimple from "@/app/components/Table/TableSimple";
    import FilterBox from "@/app/domains/Report/components/OnboardingManagement/_filterBox";
    import StatusCaptaSemTip from "@/app/domains/Records/components/EstabelecimentoComercial/_statusCaptaSemTip";
    import EtapaCapta from "@/app/domains/Records/components/EstabelecimentoComercial/_etapaCapta";
    import {getOnboardingList, getOnboardingReport} from "@/app/domains/Report/services";
    import {makeErrorFilds} from "@/app/plugins/utils";
  
    export default {
        name: "OnboardingManagementList",
        components: {
            FilterBox,
            HeaderPage,
            TableSimple,
            StatusCaptaSemTip,
            EtapaCapta,
        },
        data () {
            return {
                loadingPage: false,
                onboardingData: {},
                onboardingList: {},
                countStatus: {
                    'risk_analysis': 0,
                    'risk_analysis_reproved': 0,
                    'risk_analysis_awaiting': 0,
                    'risk_analysis_manually': 0,
                    'risk_analysis_error': 0,
                    'risk_analysis_rejected': 0,
                    'bank_account': 0,
                    'bank_account_reproved': 0,
                    'bank_account_error': 0,
                    'acquirers': 0,
                    'acquirers_reproved': 0,
                    'acquirers_error': 0,
                    'gateway': 0,
                    'gateway_reproved': 0,
                    'gateway_error': 0,
                    'plan': 0,
                    'plan_reproved': 0,
                    'terminal': 0,
                    'terminal_reproved': 0
                },
                filtros: '',
                filtros_status: [],
                statusMessages: [],
            }
        },
        methods: {
            init () {
                this.getOnboardingData('');
            },
            filterOnboardingData(ruleForm) {
                this.loadingPage = true;
                try {
                    this.filtros_status = ruleForm;
                    this.onboardingList.data = this.onboardingData.data.filter(this.filterPersonByStatus)
                } catch (e) {
                    console.log(e);
                }
                this.loadingPage = false;
            },
            filterPersonByStatus(person) {
                if (Array.isArray(this.filtros_status.status) && this.filtros_status.status.length >= 1) {
                    if (this.filtros_status.status.includes(person.status)){
                        return true;
                    }
                } else {
                    return true;
                }
            },
            async getOnboardingData (query) {
                this.loadingPage = true
                this.filtros = query;
                this.error = {}
                try {
                    let response = await getOnboardingList(query)
                    this.onboardingData = response.data;
                    this.statusMessages = response.status_messages;
                    this.onboardingList = Object.assign({}, this.onboardingData);
                    this.filterOnboardingData(this.filtros_status);
                    this.countStatus = response.count;
                } catch (e) {
                    this.error = makeErrorFilds(e)
                    this.$message({
                    showClose: true,
                    message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
                    type: 'error'
                    })
                } finally {
                    this.loadingPage = false
                }
            },
            async exportDados (query) {
                this.loadingPage = true
                this.error = {}
                try {
                    let response = await getOnboardingReport(query)
                    if (response.data != undefined && response.data != null) {
                        window.open(response.data, "_blank");
                    } else {
                    this.$message({
                        showClose: true,
                        message: "Não foi encontrado Estabelecimento Comercial",
                        type: "error",
                    });
                    }
                } catch (e) {
                    this.error = makeErrorFilds(e)
                    this.$message({
                    showClose: true,
                    message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
                    type: 'error'
                    })
                } finally {
                    this.loadingPage = false
                }
            }
        },
        mounted() {
            this.init()
        }
    }
</script>  
<style>
    .el-table__row {
        cursor: default !important;
    }
</style>
<style scoped>  
    .el-card.processando.is-always-shadow .el-card__body {
        padding: 10px !important;
    }
    .OnboardingManagementList .el-card .borderbody {
        border: solid 1px #001730;
        border-radius: 3px;
        padding:10px;
    }
    .LinhaSetas,
    .LinhaTable {
        justify-content: center;
        display: flex;
    }
    .el-card, .el-tabs  {
        max-width: none !important;
    }
</style>
  